import React, { useState } from "react";
import Layout from "../../components/layout/Layout";
import { useAuth } from "../../contexts/AuthContext";
import "./ScienceOGPage.css";

const ScienceOGPage = () => {
  const [activeTab, setActiveTab] = useState("mission");

  return (
    <Layout>
      <div className="science-og-page">
        {/* White background as specified */}
        <div className="white-background" />

        {/* Hero Section - Figma Design */}
        <div className="figma-hero-section">
          {/* Top Image */}
          <img src="/og_top.png" alt="Science OG Hero" className="hero-top-image" />

          {/* Hero Content */}
          <div className="figma-hero-content">
            <div className="hero-badge">GENESIS PROGRAM</div>
            <h1 className="hero-title">Science OG</h1>
            <p className="hero-subtitle">
              A collaborative initiative to democratize scientific knowledge.
              <br />
              Join the academic revolution and contribute to open science.
            </p>
            <div className="hero-formula">∑ Knowledge = ∞ Possibilities</div>
          </div>

          {/* Stats Section */}
          <div className="figma-stats-section">
            <div className="stat-card stat-card-1">
              <div className="stat-number">2,847</div>
              <div className="stat-label">Papers Upload</div>
            </div>
            <div className="stat-card stat-card-2">
              <div className="stat-number">124</div>
              <div className="stat-label">Contributors</div>
            </div>
            <div className="stat-card stat-card-3">
              <div className="stat-number">Incoming</div>
              <div className="stat-label">Reward Distributed</div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content-og">
          {/* Navigation Tabs */}
          <div className="figma-nav-tabs">
            <div className="tab-buttons">
              {[
                { key: "mission", label: "Mission", icon: "I." },
                { key: "contribution", label: "Contribution", icon: "II." },
                { key: "statistics", label: "Statistics", icon: "III." },
                { key: "leaderboard", label: "Leaderboard", icon: "IV." },
              ].map((tab) => (
                <button key={tab.key} className={`figma-tab ${activeTab === tab.key ? "active" : ""}`} onClick={() => setActiveTab(tab.key)}>
                  <span className="tab-number">{tab.icon}</span>
                  <span className="tab-text">{tab.label}</span>
                </button>
              ))}
            </div>
            <div className="tabs-divider"></div>
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {activeTab === "mission" && <MissionTab />}
            {activeTab === "contribution" && <ContributionTab />}
            {activeTab === "statistics" && <StatisticsTab />}
            {activeTab === "leaderboard" && <LeaderboardTab />}
          </div>
        </div>
      </div>
    </Layout>
  );
};

// Mission Tab Component - Redesigned to match Figma pixel-perfect
const MissionTab = () => (
  <div className="mission-tab-figma">
    {/* Header Section - Figma Design */}
    <div className="mission-header-section">
      <div className="mission-header-content">
        <h1 className="mission-title-large">What is Science OG</h1>
        <p className="mission-subtitle-text">
          Science OG is an experimental campaign, through community collaboration to build a<br />
          public access paper database, and distribute reward to Contributor.
        </p>
      </div>
    </div>

    {/* Main Content Section - Single Image */}
    <div className="mission-content-sections">
      <div className="mission-main-image">
        <img src="/proof_paper.png" alt="Science OG Mission Content" className="mission-content-image" />
      </div>
    </div>

    {/* How It Works Section */}
    <div className="how-it-works-section">
      <div className="how-it-works-header">
        <h1 className="mission-title-large">How It Works</h1>
      </div>

      <div className="process-steps-figma">
        <div className="process-step-figma">
          <div className="step-badge">Paper Collection:</div>
          <p className="step-description">Users upload research papers/books with DOI numbers</p>
        </div>

        <div className="process-step-figma">
          <div className="step-badge">Auto Verification:</div>
          <p className="step-description">System checks paper authenticity and validity</p>
        </div>

        <div className="process-step-figma">
          <div className="step-badge">Decentralized Storage:</div>
          <p className="step-description">Permanently and anonymously store papers on Irys Network</p>
        </div>

        <div className="process-step-figma">
          <div className="step-badge">Reward distribution:</div>
          <p className="step-description">award tokens (including SCAI and mainstream tokens) based on contribution whenever payments occur.</p>
        </div>
      </div>
    </div>
  </div>
);

// Contribute Tab Component - Redesigned with platform reward mechanism
// ContributionTab Component - Redesigned to match Figma pixel-perfect
const ContributionTab = () => {
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoType, setInfoType] = useState("");

  const showInfo = (type) => {
    setInfoType(type);
    setShowInfoModal(true);
  };

  return (
    <div className="contribution-tab-figma">
      {/* Step 1: Check Paper Eligibility */}
      <div className="contribution-step-figma">
        <div className="step-header-figma">
          <h2 className="step-title-figma">Step 1: Check Paper Eligibility</h2>
          <p className="step-description-figma">
            Input the DOI{" "}
            <button className="info-button-figma" onClick={() => showInfo("doi")}>
              [?]
            </button>{" "}
            of a paper and verify it meets our eligibility criteria.
          </p>
        </div>

        <div className="step-divider-figma"></div>

        <div className="eligibility-checks-figma">
          <div className="check-item-figma">
            <div className="check-icon-figma">✓</div>
            <div className="check-text-figma">The paper is not available in SCAI's storage yet.</div>
          </div>
          <div className="check-item-figma">
            <div className="check-icon-figma">✓</div>
            <div className="check-text-figma">
              The paper is not open access{" "}
              <button className="info-button-figma" onClick={() => showInfo("openaccess")}>
                [?]
              </button>{" "}
              (restricted-access papers are prioritized).
            </div>
          </div>
        </div>

        <div className="step-action-figma">
          <p className="action-description-figma">Use SCAI Search to verify paper availability</p>
          <button className="action-button-figma" onClick={() => (window.location.href = "/app/search")}>
            Check Paper Status
          </button>
        </div>
      </div>

      {/* Step 2: Upload Eligible Papers */}
      <div className="contribution-step-figma">
        <div className="step-header-figma">
          <h2 className="step-title-figma">Step 2: Upload Eligible Papers</h2>
          <p className="step-description-figma">
            If the paper meets the above criteria, upload it to our platform. Upon successful upload, it will be permanently stored and accessible via IRYS{" "}
            <button className="info-button-figma" onClick={() => showInfo("irys")}>
              [?]
            </button>{" "}
            decentralized storage.
          </p>
        </div>

        <div className="step-divider-figma"></div>

        <div className="upload-benefits-figma">
          <div className="benefit-card-figma">
            <div className="benefit-icon-figma">
              <img src="/proof_paper.png" alt="Storage" className="benefit-image" />
            </div>
            <div className="benefit-content-figma">
              <h3 className="benefit-title-figma">Permanent Storage</h3>
              <p className="benefit-description-figma">Stored on IRYS for eternal access</p>
            </div>
          </div>
          <div className="benefit-card-figma">
            <div className="benefit-icon-figma">
              <img src="/proof_paper.png" alt="Discovery" className="benefit-image" />
            </div>
            <div className="benefit-content-figma">
              <h3 className="benefit-title-figma">Enhanced Discovery</h3>
              <p className="benefit-description-figma">Available in Deep Research & SCAI Agent</p>
            </div>
          </div>
        </div>

        <div className="step-action-figma">
          <p className="action-description-figma">DOI Verification | Duplicate Detection | IRYS Storage</p>
          <button className="action-button-figma" onClick={() => (window.location.href = "/app/upload")}>
            Upload Papers
          </button>
        </div>
      </div>

      {/* Step 3: Earn Platform Rewards */}
      <div className="contribution-step-figma">
        <div className="step-header-figma">
          <h2 className="step-title-figma">Step 3: Earn Platform Rewards</h2>
          <p className="step-description-figma">When any payment occurs on the SCAI platform, you will receive incentives according to our guidelines. Track and collect your rewards through your profile page.</p>
        </div>

        <div className="step-divider-figma"></div>

        <div className="reward-distribution-figma">
          <div className="reward-row-figma">
            <div className="reward-card-figma">
              <div className="reward-percentage-figma">50 %</div>
              <div className="reward-info-figma">
                <h3 className="reward-title-figma">Upload</h3>
                <p className="reward-description-figma">distributed according to the volume of papers uploaded.</p>
              </div>
            </div>
            <div className="reward-card-figma">
              <div className="reward-percentage-figma">20 %</div>
              <div className="reward-info-figma">
                <h3 className="reward-title-figma">SCAI Foundation</h3>
                <p className="reward-description-figma">Platform development & maintenance</p>
              </div>
            </div>
            <div className="reward-card-figma">
              <div className="reward-percentage-figma">10 %</div>
              <div className="reward-info-figma">
                <h3 className="reward-title-figma">Original Authors</h3>
                <p className="reward-description-figma">Reserved for paper authors</p>
              </div>
            </div>
          </div>
          <div className="reward-row-figma">
            <div className="reward-card-figma">
              <div className="reward-percentage-figma">10 %</div>
              <div className="reward-info-figma">
                <h3 className="reward-title-figma">All Contributors</h3>
                <p className="reward-description-figma">Shared among all uploaders</p>
              </div>
            </div>
            <div className="reward-card-figma">
              <div className="reward-percentage-figma">10 %</div>
              <div className="reward-info-figma">
                <h3 className="reward-title-figma">Science OG NFT Holders</h3>
                <p className="reward-description-figma">NFT holders</p>
              </div>
            </div>
            <div className="reward-card-figma">
              <div className="reward-percentage-figma">Pending</div>
              <div className="reward-info-figma">
                <h3 className="reward-title-figma">Campaigns</h3>
                <p className="reward-description-figma">rewards distributed by the foundation</p>
              </div>
            </div>
          </div>
        </div>

        <div className="step-action-figma">
          <p className="action-description-figma">Track earnings and manage rewards in Settings</p>
          <button className="action-button-figma" onClick={() => (window.location.href = "/app/settings")}>
            View My Rewards
          </button>
        </div>
      </div>

      {/* Step 4: Explore SCAI Agent */}
      <div className="contribution-step-figma">
        <div className="step-header-figma">
          <h2 className="step-title-figma">Step 4: Explore SCAI Agent</h2>
          <p className="step-description-figma">You can quickly access the details of every paper in our library through our Agent, while accelerating your research and writing progress. Whether you're a scholar or not, the SCAI Agent can significantly boost your productivity.</p>
        </div>

        <div className="step-divider-figma"></div>

        <div className="agent-notice-figma">
          <p className="agent-notice-text">
            SCAI Agent is open for verified{" "}
            <button className="info-button-figma" onClick={() => showInfo("verified")}>
              [?]
            </button>{" "}
            user in Science OG season.
          </p>
        </div>

        <div className="step-action-figma">
          <button className="action-button-figma" onClick={() => (window.location.href = "/app/agent")}>
            Agent shortcut button
          </button>
        </div>
      </div>

      {/* Information Modal */}
      {showInfoModal && (
        <div className="info-modal-overlay" onClick={() => setShowInfoModal(false)}>
          <div className="info-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="info-modal-header">
              <h3>{infoType === "doi" ? "What is DOI" : infoType === "openaccess" ? "Paper Open Level" : infoType === "irys" ? "What is IRYS" : "Verified User"}</h3>
              <button className="info-modal-close" onClick={() => setShowInfoModal(false)}>
                ×
              </button>
            </div>
            <div className="info-modal-body">
              {infoType === "doi" && (
                <div>
                  <p>
                    <strong>Digital Object Identifier (DOI)</strong> is a digital identifier of a paper. You can always access a paper with URL like this: <code>https://www.doi.org/&lt;DOI:NUMBER&gt;</code>.
                  </p>
                  <p>
                    By{" "}
                    <a href="/app/search" style={{ color: "#1890ff" }}>
                      SCAI search
                    </a>{" "}
                    or other academic databases like{" "}
                    <a href="https://scholar.google.com" target="_blank" rel="noopener noreferrer" style={{ color: "#1890ff" }}>
                      Google Scholar
                    </a>{" "}
                    you can easily get metadata from the DOI of a paper.
                  </p>
                </div>
              )}
              {infoType === "openaccess" && (
                <div>
                  <p>There are two availability levels of papers:</p>
                  <ul>
                    <li>
                      <strong>Open access</strong> - The paper can be downloaded for free
                    </li>
                    <li>
                      <strong>Restricted</strong> - The paper needs a massive payment to access
                    </li>
                  </ul>
                  <p>
                    We have a strong search engine to fetch full papers as much as we could. If a paper can be found in our storage, it cannot be uploaded again. Besides, the <strong>restricted</strong> paper is the first priority, however, <strong>open access</strong> papers are also welcomed.
                  </p>
                  <p>
                    Upload an open access paper can make it available in{" "}
                    <a href="/app/search" style={{ color: "#1890ff" }}>
                      deep research
                    </a>
                    /
                    <a href="/app/agent" style={{ color: "#1890ff" }}>
                      SCAI agent
                    </a>{" "}
                    and also can be used to finish <strong>Science OG</strong> tasks.
                  </p>
                </div>
              )}
              {infoType === "irys" && (
                <div>
                  <p>
                    <strong>IRYS</strong> is a decentralized data storage network that provides permanent, immutable storage for digital content.
                  </p>
                  <p>Key features:</p>
                  <ul>
                    <li>
                      <strong>Permanent Storage</strong> - Data stored on IRYS is guaranteed to be available forever
                    </li>
                    <li>
                      <strong>Decentralized</strong> - No single point of failure, distributed across multiple nodes
                    </li>
                    <li>
                      <strong>Immutable</strong> - Once stored, data cannot be changed or deleted
                    </li>
                    <li>
                      <strong>Verifiable</strong> - Each upload gets a unique transaction ID for verification
                    </li>
                  </ul>
                  <p>
                    Learn more at{" "}
                    <a href="https://docs.irys.xyz/learn/what/what-irys-is" target="_blank" rel="noopener noreferrer" style={{ color: "#1890ff" }}>
                      IRYS Documentation
                    </a>
                  </p>
                </div>
              )}
              {infoType === "verified" && (
                <div>
                  <p>
                    <strong>Verified users</strong> are contributors who have successfully uploaded papers to the SCAI platform and have been verified by our system.
                  </p>
                  <p>Verification criteria:</p>
                  <ul>
                    <li>Successfully uploaded at least one paper</li>
                    <li>Completed profile verification</li>
                    <li>Active participation in the Science OG season</li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// StatisticsTab Component - Redesigned to match Figma pixel-perfect
const StatisticsTab = () => {
  const userStats = {
    totalPoints: 850,
    oaPoints: 400,
    raPoints: 450,
    totalPapers: 12,
    oaPapers: 40,
    raPapers: 4,
    nftWeight: 850,
    estimatedShare: 24.67,
  };

  const progressPercentage = Math.min((userStats.oaPoints / 500) * 100, 100);

  const missionTasks = [
    { id: 1, title: "Upload First Paper", description: "Submit your first research paper", completed: true, points: 50 },
    { id: 2, title: "Read 10 Papers", description: "Browse and read 10 papers from the database", completed: true, points: 25 },
    { id: 3, title: "Follow on Twitter", description: "Follow @ScienceOG on Twitter", completed: false, points: 10 },
    { id: 4, title: "Join Discord", description: "Join our Discord community", completed: false, points: 10 },
    { id: 5, title: "Upload 10 Papers", description: "Contribute 10 research papers", completed: true, points: 100 },
    { id: 6, title: "First RA Paper", description: "Upload your first restricted access paper", completed: false, points: 200 },
    { id: 7, title: "Share on Social", description: "Share Science OG on social media", completed: false, points: 15 },
    { id: 8, title: "Refer a Friend", description: "Invite someone to join Science OG", completed: false, points: 50 },
  ];

  const completedTasks = missionTasks.filter((task) => task.completed).length;
  const totalTasks = missionTasks.length;
  const taskProgress = Math.round((completedTasks / totalTasks) * 100);
  const remainingTasks = totalTasks - completedTasks;
  const nftUnlocked = completedTasks >= totalTasks;

  return (
    <div className="statistics-tab-figma">
      {/* Science OG NFT Section */}
      <div className="nft-section-figma">
        <div className="nft-container-figma">
          <div className="nft-image-figma">
            <img src="/science_og_nft.png" alt="Science OG NFT" className="nft-badge-figma" />
          </div>
          <div className="nft-content-figma">
            <div className="nft-header-figma">
              <h2 className="nft-title-figma">Science OG NFT</h2>
              <p className="nft-description-figma">{nftUnlocked ? "Congratulations! Your NFT is ready to claim" : `Complete ${remainingTasks} more tasks to unlock your NFT`}</p>
            </div>
            <button className={nftUnlocked ? "nft-claim-button-active-figma" : "nft-claim-button-disabled-figma"} disabled={!nftUnlocked} onClick={() => nftUnlocked && alert("NFT Claimed Successfully!")}>
              Claim NFT
            </button>
          </div>
        </div>
      </div>

      {/* My Data Section */}
      <div className="my-data-section-figma">
        <div className="data-header-figma">
          <h2 className="data-title-figma">My Data</h2>
        </div>

        <div className="data-divider-figma"></div>

        <div className="data-grid-figma">
          <div className="data-card-figma">
            <div className="data-number-figma">850</div>
            <div className="data-info-figma">
              <div className="data-label-figma">Total Points</div>
              <div className="data-note-figma">OA+RA Combined</div>
            </div>
          </div>
          <div className="data-card-figma">
            <div className="data-number-figma">12</div>
            <div className="data-info-figma">
              <div className="data-label-figma">Papers Contributed</div>
              <div className="data-note-figma">Cumulative Count</div>
            </div>
          </div>
          <div className="data-card-figma">
            <div className="data-number-figma">850</div>
            <div className="data-info-figma">
              <div className="data-label-figma">NFT Weight</div>
              <div className="data-note-figma">Revenue Share Basis</div>
            </div>
          </div>
          <div className="data-card-figma">
            <div className="data-number-figma">$24.67</div>
            <div className="data-info-figma">
              <div className="data-label-figma">Monthly Estimate</div>
              <div className="data-note-figma">Based on Current Weight</div>
            </div>
          </div>
        </div>

        <div className="progress-card-figma">
          <div className="progress-header-figma">
            <span className="progress-label-figma">OA Paper Progress</span>
            <span className="progress-text-figma">400 / 500 Points (80.0%)</span>
          </div>
          <div className="progress-bar-container-figma">
            <div className="progress-bar-bg-figma"></div>
            <div className="progress-bar-fill-figma" style={{ width: "80%" }}></div>
          </div>
        </div>
      </div>

      {/* Mission Tasks Section */}
      <div className="mission-tasks-section-figma">
        <div className="mission-header-figma">
          <h2 className="mission-title-figma">Mission Tasks</h2>
          <p className="mission-description-figma">Complete these tasks to earn your Science OG NFT and bonus points. Each completed task brings you closer to the full benefits of our platform.</p>
        </div>

        <div className="mission-divider-figma"></div>

        <div className="mission-progress-card-figma">
          <div className="mission-progress-header-figma">
            <span className="mission-progress-label-figma">OA Paper Progress</span>
            <span className="mission-progress-text-figma">
              {completedTasks} / {totalTasks} Tasks ({taskProgress}%)
            </span>
          </div>
          <div className="mission-progress-bar-container-figma">
            <div className="mission-progress-bar-bg-figma"></div>
            <div className="mission-progress-bar-fill-figma" style={{ width: `${taskProgress}%` }}></div>
          </div>
        </div>

        <div className="task-grid-figma">
          {/* Row 1 */}
          <div className="task-row-figma">
            <div className={`task-card-figma ${missionTasks[0].completed ? "completed" : ""}`}>
              <div className="task-icon-figma">{missionTasks[0].completed ? "✓" : "○"}</div>
              <div className="task-content-figma">
                <div className="task-title-figma">{missionTasks[0].title}</div>
                <div className="task-description-figma">{missionTasks[0].description}</div>
              </div>
              {missionTasks[0].completed ? (
                <div className="task-points-figma">+{missionTasks[0].points} pts</div>
              ) : (
                <div className="task-action-figma">
                  <button className="task-start-button-figma">Start</button>
                  <div className="task-points-figma">+{missionTasks[0].points} pts</div>
                </div>
              )}
            </div>
            <div className={`task-card-figma ${missionTasks[1].completed ? "completed" : ""}`}>
              <div className="task-icon-figma">{missionTasks[1].completed ? "✓" : "○"}</div>
              <div className="task-content-figma">
                <div className="task-title-figma">{missionTasks[1].title}</div>
                <div className="task-description-figma">{missionTasks[1].description}</div>
              </div>
              {missionTasks[1].completed ? (
                <div className="task-points-figma">+{missionTasks[1].points} pts</div>
              ) : (
                <div className="task-action-figma">
                  <button className="task-start-button-figma">Start</button>
                  <div className="task-points-figma">+{missionTasks[1].points} pts</div>
                </div>
              )}
            </div>
          </div>

          {/* Row 2 */}
          <div className="task-row-figma">
            <div className={`task-card-figma ${missionTasks[2].completed ? "completed" : ""}`}>
              <div className="task-icon-figma">{missionTasks[2].completed ? "✓" : "○"}</div>
              <div className="task-content-figma">
                <div className="task-title-figma">{missionTasks[2].title}</div>
                <div className="task-description-figma">{missionTasks[2].description}</div>
              </div>
              {missionTasks[2].completed ? (
                <div className="task-points-figma">+{missionTasks[2].points} pts</div>
              ) : (
                <div className="task-action-figma">
                  <button className="task-start-button-figma">Start</button>
                  <div className="task-points-figma">+{missionTasks[2].points} pts</div>
                </div>
              )}
            </div>
            <div className={`task-card-figma ${missionTasks[3].completed ? "completed" : ""}`}>
              <div className="task-icon-figma">{missionTasks[3].completed ? "✓" : "○"}</div>
              <div className="task-content-figma">
                <div className="task-title-figma">{missionTasks[3].title}</div>
                <div className="task-description-figma">{missionTasks[3].description}</div>
              </div>
              {missionTasks[3].completed ? (
                <div className="task-points-figma">+{missionTasks[3].points} pts</div>
              ) : (
                <div className="task-action-figma">
                  <button className="task-start-button-figma">Start</button>
                  <div className="task-points-figma">+{missionTasks[3].points} pts</div>
                </div>
              )}
            </div>
          </div>

          {/* Row 3 */}
          <div className="task-row-figma">
            <div className={`task-card-figma ${missionTasks[4].completed ? "completed" : ""}`}>
              <div className="task-icon-figma">{missionTasks[4].completed ? "✓" : "○"}</div>
              <div className="task-content-figma">
                <div className="task-title-figma">{missionTasks[4].title}</div>
                <div className="task-description-figma">{missionTasks[4].description}</div>
              </div>
              {missionTasks[4].completed ? (
                <div className="task-points-figma">+{missionTasks[4].points} pts</div>
              ) : (
                <div className="task-action-figma">
                  <button className="task-start-button-figma">Start</button>
                  <div className="task-points-figma">+{missionTasks[4].points} pts</div>
                </div>
              )}
            </div>
            <div className={`task-card-figma ${missionTasks[5].completed ? "completed" : ""}`}>
              <div className="task-icon-figma">{missionTasks[5].completed ? "✓" : "○"}</div>
              <div className="task-content-figma">
                <div className="task-title-figma">{missionTasks[5].title}</div>
                <div className="task-description-figma">{missionTasks[5].description}</div>
              </div>
              {missionTasks[5].completed ? (
                <div className="task-points-figma">+{missionTasks[5].points} pts</div>
              ) : (
                <div className="task-action-figma">
                  <button className="task-start-button-figma">Start</button>
                  <div className="task-points-figma">+{missionTasks[5].points} pts</div>
                </div>
              )}
            </div>
          </div>

          {/* Row 4 */}
          <div className="task-row-figma">
            <div className={`task-card-figma ${missionTasks[6].completed ? "completed" : ""}`}>
              <div className="task-icon-figma">{missionTasks[6].completed ? "✓" : "○"}</div>
              <div className="task-content-figma">
                <div className="task-title-figma">{missionTasks[6].title}</div>
                <div className="task-description-figma">{missionTasks[6].description}</div>
              </div>
              {missionTasks[6].completed ? (
                <div className="task-points-figma">+{missionTasks[6].points} pts</div>
              ) : (
                <div className="task-action-figma">
                  <button className="task-start-button-figma">Start</button>
                  <div className="task-points-figma">+{missionTasks[6].points} pts</div>
                </div>
              )}
            </div>
            <div className={`task-card-figma ${missionTasks[7].completed ? "completed" : ""}`}>
              <div className="task-icon-figma">{missionTasks[7].completed ? "✓" : "○"}</div>
              <div className="task-content-figma">
                <div className="task-title-figma">{missionTasks[7].title}</div>
                <div className="task-description-figma">{missionTasks[7].description}</div>
              </div>
              {missionTasks[7].completed ? (
                <div className="task-points-figma">+{missionTasks[7].points} pts</div>
              ) : (
                <div className="task-action-figma">
                  <button className="task-start-button-figma">Start</button>
                  <div className="task-points-figma">+{missionTasks[7].points} pts</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Leaderboard Tab Component - Figma Pixel Perfect Implementation
const LeaderboardTab = () => {
  const leaderboardData = [
    { rank: 1, name: "Dr. Sarah Chen", institution: "MIT", points: 12450, weight: 12450, papers: 124 },
    { rank: 2, name: "Prof. Michael Zhang", institution: "Stanford", points: 11200, weight: 11200, papers: 89 },
    { rank: 3, name: "Dr. Anna Rodriguez", institution: "Harvard", points: 9800, weight: 9800, papers: 67 },
    { rank: 4, name: "Prof. James Wilson", institution: "Cambridge", points: 8750, weight: 8750, papers: 92 },
    { rank: 5, name: "Dr. Lisa Wang", institution: "Berkeley", points: 7650, weight: 7650, papers: 58 },
    { rank: 6, name: "Prof. David Kumar", institution: "Oxford", points: 6900, weight: 6900, papers: 71 },
    { rank: 7, name: "Dr. Emma Thompson", institution: "ETH Zurich", points: 6200, weight: 6200, papers: 43 },
    { rank: 8, name: "Prof. Alex Johnson", institution: "Caltech", points: 5800, weight: 5800, papers: 39 },
    { rank: 9, name: "Dr. Maria Garcia", institution: "Columbia", points: 5400, weight: 5400, papers: 62 },
    { rank: 10, name: "Prof. Robert Lee", institution: "Princeton", points: 4950, weight: 4950, papers: 35 },
  ];

  const communityStats = [
    { label: "Total Contributors", value: "1,247 People" },
    { label: "Total Papers", value: "15,892 Papers" },
    { label: "Open Access", value: "12,108 Papers (76.2 %)" },
    { label: "Restricted Papers", value: "3, 784 Papers (23.8 %)" },
    { label: "Monthly Revenue", value: "$8,245.30" },
    { label: "Total Distributed", value: "$47 ,891.20" },
    { label: "Average Paper Price", value: "$0.52" },
    { label: "Citation Boost", value: "+23.78 %" },
  ];

  return (
    <div className="leaderboard-tab-figma">
      {/* Global Leaderboard Section */}
      <div className="global-leaderboard-section-figma">
        <div className="leaderboard-header-figma">
          <h2 className="leaderboard-title-figma">Global Leaderboard</h2>
          <p className="leaderboard-description-figma">Top contributors ranked by NFT weight. These researchers have established excellent reputation in the Science OG community through continuous contribution of high-quality papers.</p>
        </div>

        <div className="leaderboard-divider-figma"></div>

        <div className="leaderboard-list-figma">
          {leaderboardData.map((contributor, index) => (
            <div key={contributor.rank} className={`leaderboard-item-figma ${index < 3 ? "top-three-figma" : "regular-figma"}`}>
              <div className="contributor-section-figma">
                <div className="rank-section-figma">
                  <div className="rank-number-figma">{contributor.rank}</div>
                  {index < 3 && <div className="rank-trophy-figma">🏆</div>}
                </div>
                <div className="contributor-info-figma">
                  <div className="contributor-name-figma">{contributor.name}</div>
                  <div className="contributor-institution-figma">{contributor.institution}</div>
                </div>
              </div>

              <div className="metrics-section-figma">
                <div className="metric-item-figma">
                  <div className="metric-value-figma">{contributor.points.toLocaleString()}</div>
                  <div className="metric-label-figma">Points</div>
                </div>
                <div className="metric-item-figma">
                  <div className="metric-value-figma">{contributor.weight.toLocaleString()}</div>
                  <div className="metric-label-figma">Weight</div>
                </div>
                <div className="metric-item-figma">
                  <div className="metric-value-figma">{contributor.papers}</div>
                  <div className="metric-label-figma">Papers</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Community Statistics Section */}
      <div className="community-statistics-section-figma">
        <div className="community-header-figma">
          <h2 className="community-title-figma">Community Statistics</h2>
        </div>

        <div className="community-divider-figma"></div>

        <div className="community-stats-grid-figma">
          {communityStats.map((stat, index) => (
            <div key={index} className="community-stat-card-figma">
              <div className="stat-content-figma">
                <div className="stat-label-figma">{stat.label}</div>
                <div className="stat-value-figma">{stat.value}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Reward Factor Section */}
        <div className="reward-factor-section-figma">
          <div className="reward-factor-header-figma">
            <div className="reward-factor-badge-figma">Reward Factor =</div>
          </div>
          <div className="reward-factor-formula-figma">
            ( 1 * 0.5 * Upload Paper / Total Paper )
            <br />
            +
            <br />
            ( 1 * 0.1 / Total Uploaded User )
            <br />
            +
            <br />( 1 * 0.1 / Total OG )
          </div>
        </div>
      </div>
    </div>
  );
};

// My Data Tab Component - User's personal upload and earnings data
const MyDataTab = () => {
  // 从AuthContext获取认证状态
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return (
      <div className="scientific-flow">
        <div className="flow-section">
          <div className="section-content" style={{ textAlign: "center", padding: "60px 20px" }}>
            <div style={{ fontSize: "48px", marginBottom: "24px", color: "#1890ff" }}>🔐</div>
            <h3 className="section-title">
              <span style={{ color: "#000" }}>Connect Your Wallet</span>
            </h3>
            <p className="flow-text">
              <span style={{ color: "#333" }}>
                You need to connect your wallet to view your personal upload and earnings data.
                <br />
                Use the wallet button in the header to get started.
              </span>
            </p>
            <div className="formula-highlight" style={{ marginTop: "24px" }}>
              <span style={{ color: "#000" }}>Personal Data = Authentication Required</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 已认证用户的数据展示
  const userUploadStats = {
    totalUploads: 15,
    totalViews: 1250,
    totalDownloads: 340,
    totalEarnings: 125.5,
  };

  const recentUploads = [
    {
      title: "Machine Learning in Healthcare",
      doi: "10.1000/ml-healthcare-2024",
      date: "2024-01-15",
      views: 150,
      downloads: 45,
      earnings: 12.5,
    },
    {
      title: "Quantum Computing Applications",
      doi: "10.1000/quantum-apps-2024",
      date: "2024-01-10",
      views: 200,
      downloads: 60,
      earnings: 18.0,
    },
    {
      title: "AI Ethics Framework",
      doi: "10.1000/ai-ethics-2024",
      date: "2024-01-05",
      views: 300,
      downloads: 85,
      earnings: 25.5,
    },
  ];

  const recentEarnings = [
    {
      date: "2024-01-15",
      amount: 12.5,
      source: "Paper Downloads",
      paper: "Machine Learning in Healthcare",
    },
    {
      date: "2024-01-10",
      amount: 18.0,
      source: "Paper Downloads",
      paper: "Quantum Computing Applications",
    },
    {
      date: "2024-01-05",
      amount: 25.5,
      source: "Paper Downloads",
      paper: "AI Ethics Framework",
    },
  ];

  return (
    <div className="scientific-flow">
      {/* 统计概览 */}
      <div className="flow-section">
        <div className="section-content">
          <h3 className="section-title">
            <span style={{ color: "#000" }}>Upload Statistics</span>
          </h3>
          <div
            className="stats-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "20px",
              marginBottom: "30px",
            }}
          >
            <div
              className="stat-card"
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                padding: "20px",
                borderRadius: "12px",
                textAlign: "center",
                border: "1px solid rgba(0, 0, 0, 0.1)",
              }}
            >
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#1890ff" }}>{userUploadStats.totalUploads}</div>
              <div style={{ color: "#666", fontSize: "14px" }}>Total Uploads</div>
            </div>
            <div
              className="stat-card"
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                padding: "20px",
                borderRadius: "12px",
                textAlign: "center",
                border: "1px solid rgba(0, 0, 0, 0.1)",
              }}
            >
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#52c41a" }}>{userUploadStats.totalViews.toLocaleString()}</div>
              <div style={{ color: "#666", fontSize: "14px" }}>Total Views</div>
            </div>
            <div
              className="stat-card"
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                padding: "20px",
                borderRadius: "12px",
                textAlign: "center",
                border: "1px solid rgba(0, 0, 0, 0.1)",
              }}
            >
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#722ed1" }}>{userUploadStats.totalDownloads}</div>
              <div style={{ color: "#666", fontSize: "14px" }}>Total Downloads</div>
            </div>
            <div
              className="stat-card"
              style={{
                background: "rgba(255, 255, 255, 0.9)",
                padding: "20px",
                borderRadius: "12px",
                textAlign: "center",
                border: "1px solid rgba(0, 0, 0, 0.1)",
              }}
            >
              <div style={{ fontSize: "24px", fontWeight: "bold", color: "#f5222d" }}>${userUploadStats.totalEarnings.toFixed(2)}</div>
              <div style={{ color: "#666", fontSize: "14px" }}>Total Earnings</div>
            </div>
          </div>
          <div className="formula-highlight">
            <span style={{ color: "#000" }}>Impact Score = Views × 0.1 + Downloads × 0.5 + Citations × 2.0</span>
          </div>
        </div>
      </div>

      {/* 最近上传 */}
      <div className="flow-section">
        <div className="section-content">
          <h3 className="section-title">
            <span style={{ color: "#000" }}>Recent Uploads</span>
          </h3>
          <div className="uploads-list" style={{ marginBottom: "20px" }}>
            {recentUploads.map((upload, index) => (
              <div
                key={index}
                style={{
                  background: "rgba(255, 255, 255, 0.9)",
                  padding: "16px",
                  borderRadius: "8px",
                  marginBottom: "12px",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                }}
              >
                <div style={{ fontWeight: "bold", marginBottom: "4px", color: "#000" }}>{upload.title}</div>
                <div style={{ fontSize: "12px", color: "#666", marginBottom: "8px" }}>DOI: {upload.doi}</div>
                <div style={{ display: "flex", gap: "16px", fontSize: "14px", color: "#666" }}>
                  <span>{upload.date}</span>
                  <span>•</span>
                  <span>{upload.views} views</span>
                  <span>•</span>
                  <span>{upload.downloads} downloads</span>
                  <span>•</span>
                  <span style={{ color: "#52c41a", fontWeight: "bold" }}>${upload.earnings}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 最近收入 */}
      <div className="flow-section">
        <div className="section-content">
          <h3 className="section-title">
            <span style={{ color: "#000" }}>Recent Earnings</span>
          </h3>
          <div className="earnings-list">
            {recentEarnings.map((earning, index) => (
              <div
                key={index}
                style={{
                  background: "rgba(255, 255, 255, 0.9)",
                  padding: "16px",
                  borderRadius: "8px",
                  marginBottom: "12px",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>
                  <div style={{ fontWeight: "bold", color: "#52c41a", fontSize: "16px" }}>+${earning.amount}</div>
                  <div style={{ fontSize: "14px", color: "#666" }}>from {earning.source}</div>
                  <div style={{ fontSize: "12px", color: "#999" }}>{earning.paper}</div>
                </div>
                <div style={{ fontSize: "12px", color: "#666" }}>{earning.date}</div>
              </div>
            ))}
          </div>
          <div className="formula-highlight">
            <span style={{ color: "#000" }}>Earnings = Downloads × Base Rate × Quality Multiplier</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScienceOGPage;
